import Vue from 'vue'
import VueRouter from 'vue-router'
// 引入其他路由
import { home } from '../router/home.js'
import Cookies from 'js-cookie'
import { Message } from 'element-ui'
import { setTokenWithExpire, getTokenWithExpire, removeToken, isTokenValid } from "../utils/tokenUtils.js";
Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: () =>
            import ("../views/login/index.vue"),
    },
    {
        path: '/dologin',
        name: 'DoLogin',
        component: () =>
            import ("../views/login/login.vue"),
    },
    {
        path: '/completion',
        name: 'Completion',
        component: () =>
            import ("../views/completion"),
        meta: {
            title: "信息完善"
        },
    },
    {
        path: '/user-center',
        name: 'UserCenter',
        component: () =>
            import ("../views/UserCenter.vue"),
        meta: {
            title: "用户中心"
        },
    },
    {
        path: '/admin',
        name: 'Admin',
        component: () =>
            import ("../views/Admin.vue"),
        meta: {
            title: "运营后台"
        },
        children: [
            {
                path: '/product',
                name: 'Product',
                component: () => import('../views/product/index.vue'),
                meta: { title: "产品列表" }
            },
            {
                path: "/product-add",
                name: 'ProductAdd',
                component: () => import('../views/product/add.vue'),
                meta: { title: "产品发布/添加" }
            },
            {
                path: '/product-detail',
                name: 'ProductDetail',
                component: () =>
                    import ("../views/product/detail.vue"),
                meta: {
                    title: "产品详情"
                },
            },
            {
                path: '/product-edit',
                name: 'ProductEdit',
                component: () =>
                    import ("../views/product/edit.vue"),
                meta: {
                    title: "产品编辑"
                },
            },
            {
                path: '/account',
                name: 'Account',
                component: () => import('../views/account/index.vue'),
                meta: { title: "账号列表" }
            },
            {
                path: '/account-edit',
                name: 'AccountEdit',
                component: () => import('../views/account/edit.vue'),
                meta: { title: "账号编辑" }
            },
        ]
    },
    
    ...home,
]

const router = new VueRouter({
    mode: 'history', // 去掉#，默认为hash
    base: process.env.NODE_ENV === 'production' ? '/web/' : '/',
    routes
})

// 路由导航守卫：根据是否存在token跳转不同路由
router.beforeEach(function(to, from, next) {
    //用户login登录 直接放行跳转
    if (to.path === '/' || to.path === '/login' || to.path === '/dologin' || to.path === '/home') {
        next();
    } else {
        // 获取token
        let token =getTokenWithExpire('token');
        // 有无token跳转（有token，直接放行跳转、无token，返回首页） 
        if (token) {
            next();
        } else {
            Message.error('您尚未登录请先登录！');
            setTimeout(function() { next({ path: '/login' }) }, 1000);
        }
    }

});

const originalPush = router.push
router.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      console.error(err)
    }
  })
}

export default router